module.exports = __webpack_public_path__ + "img/csv.6b5fa54a.svg";